import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { HeaderAndNavigationService } from '../headerandnavigation/headerandnavigation.service';

@Component({
  templateUrl: "./mydriversclub.new.component.html"
})
export class MyDriversClubNewComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'My Drivers Club';
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public headerAndNavigationService: HeaderAndNavigationService,
  ) {
    this.appCommonService.pageName = this.pageTitle;
    this.appCommonService.pageContentAdditionalClass = "dashboard-page";
  }
  ngOnInit() {
    this.headerAndNavigationService.showhideNav(true, false);
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/home/mydriversclub.new.component.ts